var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.chartData || _vm.chartData.length === 0)?_c('el-alert',{staticStyle:{"margin-top":"20px"},attrs:{"title":"暂无数据","type":"info","show-icon":""}}):_vm._e(),_c('div',{ref:"chartContainer",staticStyle:{"width":"100%","height":"500px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }